import React from 'react';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';



export default function Copyright() {
	return (
	<React.Fragment>
		<Typography variant="body2" color="textSecondary" align="center">
			{'Copyright © '}
			<Link color="inherit" href="https://ilmaturva.fi/">
			Airlyze - Ilmaturva
			</Link>{' '}
			{new Date().getFullYear()}
			{'.'}
		</Typography>
	  </React.Fragment>
	);
  }